/*! @azure/msal-browser v2.28.3 2022-09-12 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-browser";
var version = "2.28.3";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
